<!-- \src\components\ConfirmModal.vue -->
<template>
  <div v-if="show" class="confirm-modal-overlay">
    <div class="confirm-modal-dialog">
      <div class="confirm-modal-content">
        <div class="confirm-modal-body">
          <p>{{ message }}</p>
          <p>
            <strong>{{ prompt }}</strong>
          </p>
        </div>
        <div class="confirm-modal-footer">
          <button
            @click="confirm(true)"
            :class="['confirm-modal-btn', confirmType]"
          >
            {{ confirmText }}
          </button>
          <button
            @click="confirm(false)"
            :class="['confirm-modal-btn', cancelType]"
          >
            {{ cancelText }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'ConfirmModal',
  props: {
    show: {
      type: Boolean,
      required: true,
    },
    message: {
      type: String,
      default: 'Are you sure you want to proceed?',
    },
    prompt: {
      type: String,
      default: 'Please confirm your action.',
    },
    confirmText: {
      type: String,
      default: 'Yes',
    },
    cancelText: {
      type: String,
      default: 'No',
    },
    confirmType: {
      type: String,
      default: 'confirm-modal-btn-primary',
    },
    cancelType: {
      type: String,
      default: 'confirm-modal-btn-danger',
    },
  },
  emits: ['confirm'],
  setup(props, { emit }) {
    const confirm = (value: boolean) => {
      emit('confirm', value);
    };
    return { confirm };
  },
});
</script>

<style scoped>
.confirm-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1;
}

.confirm-modal-dialog {
  width: 500px;
  max-width: 90%;
}

.confirm-modal-content {
  background-color: #fff;
  border-radius: 0.3rem;
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
}

.confirm-modal-body {
  padding: 1rem;
}

.confirm-modal-footer {
  padding: 0.75rem;
  border-top: 1px solid #dee2e6;
  display: flex;
  justify-content: flex-end;
}

.confirm-modal-btn {
  padding: 0.375rem 0.75rem;
  border-radius: 0.25rem;
  font-size: 1rem;
  line-height: 1.5;
  cursor: pointer;
  border: none;
}

.confirm-modal-btn-primary {
  color: #fff;
  background-color: #007bff;
}

.confirm-modal-btn-danger {
  color: #fff;
  background-color: #dc3545;
  margin-left: 0.5rem;
}
</style>
